import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @Input() previewImage: string;
  @Output() fileChosen = new EventEmitter<File>();
  public files: any = [];
  public loading: boolean;
  public fileSelected: boolean = false;

  constructor() {}
  ngOnInit(): void {
  }
  capturedFile(event): any {
    this.files = [];
    const capturedFiles = event.target.files[0];
    console.log('este si es el file', capturedFiles);

    const reader = new FileReader();
    reader.onload = () => {
      this.previewImage = reader.result as string; // Asigna la base64 resultante a previewImage
      this.fileSelected = true;
    };
    reader.readAsDataURL(capturedFiles);

    this.files.push(capturedFiles);
    console.log('este es el producto final', capturedFiles);
    this.fileChosen.emit(capturedFiles); // Emitir el archivo seleccionado con el nombre de evento fileChosen
  }
}
